import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "fileSizePipe" })
export class FileSizePipe implements PipeTransform {
  transform(kilobytes: number, decimals: number = 2): string {
    if (kilobytes === null || kilobytes === undefined || isNaN(kilobytes)) return 'N/A';

    if (kilobytes === 0) return '0 KB';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(kilobytes) / Math.log(k));

    return parseFloat((kilobytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
